module.exports = __webpack_public_path__ + "static/G2-b357df90a9f0e08d97504f36a3059ea7.png";